(() => {
  if (window.productShowcaseSpecsInitialized) return;

  window.productShowcaseSpecsInitialized = true;
  const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('pointerover', (event) => {
    if (!hoverMedia.matches) return;

    const disclosure = event.target.closest('[data-product-showcase-specs]');
    if (!disclosure || disclosure.contains(event.relatedTarget)) return;

    disclosure.open = true;
  });

  document.addEventListener('pointerout', (event) => {
    if (!hoverMedia.matches) return;

    const disclosure = event.target.closest('[data-product-showcase-specs]');
    if (!disclosure || disclosure.contains(event.relatedTarget)) return;

    disclosure.open = false;
  });
})();
